import { AbstractControl, ValidationErrors } from '@angular/forms';

export class DateValidator {

    /**
     * Validator to check if the date range is valid.
     * Ensures that if one date (start or end) is provided, the other must also be provided.
     * 
     * @param control - The form group containing the start and end date controls.
     * @returns ValidationErrors | null - An object containing validation errors or null if the range is valid.
     */
    static range(control: AbstractControl): ValidationErrors | null {
        // Get the start and end date controls from the form group
        const start = control.get('start');
        const end = control.get('end'); 

        // If either the start or end control is not present, return null (no validation error)
        if (!start || !end) {
            return null;
        }

        // Extract the date values from the controls
        const startDate = start.value;
        const endDate = end.value;

        // Check if one date is provided without the other
        if ((!startDate && endDate) || (startDate && !endDate)) {
            return { InvalidDateRange: true };  // Return validation error if only one date is provided
        }

        return null;  // If all checks pass, return null (no validation error)
    }
}